import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

@Injectable()
export class StorageService {

    constructor() {
    }

    /**
    * Atualiza
    * @param userId
    * @param file
    */
    uploadPhoto(path: string, file: any) {
        return firebase
            .storage()
            .ref()
            .child(path)
            .put(file);
    }

    /**
     *
     * @param path
     */
    getPhotoUrl(path: string) {
        return firebase.storage().ref(path).getDownloadURL();
    }
}
